import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ClinicalMessageService
{

  constructor(
    private http: HttpClient
  ) { }

  /**
   * Get message content.
   *
   * @param id FieldConfiguration id
   */
  public getClinicalMessageContent(id: number): Observable<string>
  {
    return this.http.get(`/queue/content/${id}`, { responseType: 'text' });
  }

  /**
   * Reprocess a message by re-adding to the queue
   *
   * @param id MessageId
   */
  public reprocessMessage(messageId: number): Observable<any>
  {
    return this.http.post(`/queue/reprocess/${messageId}`, null);
  }
}
